<template>
    <div class="s-input" :class="containerClass">
        <div class="title_container" v-if="inMore">
            <div class="title_mid">{{ label }}</div>
        </div>
        <div class="content">
            <im-input
                :theme="theme"
                v-model:value="modelVal"
                @input="handleChange('input', $event)"
                @blur="handleChange('blur', $event)"
            />
        </div>
    </div>
</template>

<script>
import classNames from 'classnames';
import util from '@/common/util';
export default {
    name: 'SInput',
    emits: ['change', 'update:value'],
    props: {
        theme: {
            validator: val =>
                ['standard', 'template1', 'template4', 'broker'].includes(val),
            default: 'standard'
        },
        label: {
            // title
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        data: {
            type: Object,
            default: () => ({})
        },
        kee: {
            type: String,
            default: ''
        },
        inMore: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        containerClass() {
            return classNames(this.theme);
        },
        options() {
            return this.data.mask;
        }
    },
    created() {
        this.change = util.debounce(this.change).bind(this);
    },
    data: function() {
        return {
            modelVal: this.value
        };
    },
    watch: {
        value() {
            this.modelVal = this.value;
        }
    },
    methods: {
        handleChange(eventType, val) {
            if (eventType === 'blur' && this.options.lazy) {
                this.change(val);
            } else if (eventType === 'input' && !this.options.lazy) {
                this.change(val);
            }
        },
        change(val) {
            this.$emit('change', {
                kee: this.kee,
                value: val,
                type: 'text'
            });
        }
    }
};
</script>

<style lang="scss">
.s-input {
    width: 100%;
    &.standard {
        color: #515666;
        font-size: 14px;
    }
    &.template1 {
        font-size: 14px;
        color: #282828;
    }
    &.template4 {
        font-size: 17px;
        color: #6b7282;
    }
    .title_container {
        margin-bottom: 10px;
    }
    .content {
        height: 40px;
        display: flex;
        align-items: center;
        justify-items: flex-start;
    }
}

</style>
